import { makeStyles } from "@mui/styles";
import React from "react";

import {
  alertCSS,
  alertInfoCSS,
  alertErrorCSS,
  alertSuccessCSS,
  alertDuplicateCSS,
  alertWithInfoIconCSS,
} from "../shared/AlertCSS";

//Constants
import { GLOBAL_MESSAGE_STATUS } from "../../constants/GlobalConstants";

const useStyles = makeStyles(() => ({
  alert: alertCSS,
  alertInfo: alertInfoCSS,
  alertError: alertErrorCSS,
  alertSuccess: alertSuccessCSS,
  alertDuplicate: alertDuplicateCSS,
  alertWithInfoIcon: alertWithInfoIconCSS,
}));

export default function MDCBanner({
  message,
  error,
  success,
  isDuplicate,
  isInfoIcon,
  isIcon = "",
}) {
  const {
    alert,
    alertInfo,
    alertSuccess,
    alertError,
    alertDuplicate,
    alertWithInfoIcon,
  } = useStyles();

  let MDCStyles = `${alert}`;

  if (error || isIcon === GLOBAL_MESSAGE_STATUS.ERROR) {
    MDCStyles = `${MDCStyles} ${alertError}`;
  } else if (success || isIcon === GLOBAL_MESSAGE_STATUS.SUCCESS) {
    MDCStyles = `${MDCStyles} ${alertSuccess}`;
  } else if (isDuplicate || isIcon === GLOBAL_MESSAGE_STATUS.DUPLICATE) {
    MDCStyles = `${MDCStyles} ${alertDuplicate}`;
  } else if (isInfoIcon || isIcon === GLOBAL_MESSAGE_STATUS.INFO) {
    MDCStyles = `${MDCStyles} ${alertWithInfoIcon}`;
  } else {
    MDCStyles = `${MDCStyles} ${alertInfo}`;
  }

  return (
    <div className={`${MDCStyles}`}>
      <span>{message}</span>
    </div>
  );
}
